var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signin-card"},[_c('p',{staticClass:"signin-card_title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"signin-card_content"},[_vm._t("default")],2),_c('div',{staticClass:"signin-card_bottom-btns"},[_vm._t("bottom-btns")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }